/**
 * @internal
 */
export class SessionMock {
    deleteUserFromSessionStorage() { }
    setStorageKeyPrefix(prefix) { }
    setAuthResult(loginResult) { }
    captureReturnUrl() { }
    setItem(key, value) { }
    getItem(key) {
        return this.nextStorageItem;
    }
    removeItem(key) { }
    setLocalStorageItem(key, value) { }
    setSessionStorageItem(key, value) { }
    getLocalStorageItem(key) {
        return this.nextStorageItem;
    }
    getSessionStorageItem(key) {
        return this.nextStorageItem;
    }
    removeLocalStorageItem(key) { }
    removeSessionStorageItem(key) { }
}
